// Componentes nativos
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

// Componentes personalizados
import Header from "../../Header";

// Funções de formatação de resultados
import { porcentagem, massaMolar } from "../../../utils/formatar";

// Ícones
import { IoMdArrowRoundBack } from "react-icons/io";

// Classes de controle e de armazenamento
import Substancia, { Composicao } from "../Core/Substancia";

export default function MassaMolar() {
    // Gerencia a navegação
    const nav = useHistory();
    function back() {
        nav.goBack();
    }

    // Gerencia a fórmula informada
    const [formula, setFormula] = useState("");
    const [mm, setMassaMolar] = useState(0);
    const [composicao, setComposicao] = useState<Composicao[]>([]);

    // Gerencia o alerta e o estado de carregamento
    const [carregado, setCarregado] = useState(false);
    const [alerta, setAlerta] = useState("");

    // Função para cálculo
    function calcular() {
        const subs = new Substancia(formula, "Genérico");
        if(subs.getErro()) {
            setAlerta(subs.getMessage());
            setCarregado(false);
        } else {
            setMassaMolar(subs.getMassaMolar());
            setComposicao(subs.getComposicao());
            setCarregado(true);
            setAlerta("");
        }
    }

    // Função para alteração do input da fórmula molecular
    function alterar(event: React.ChangeEvent<HTMLInputElement>) {
        setFormula(event.target.value);
        setAlerta("");
    }

    // Função de renderização
    function render() {
        if(alerta != "") {
            setCarregado(false);
            return;
        }

        calcular();
    }

    useEffect(() => {
        render();
    }, [formula]);

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">

                    <div className="linha-titulo">
                        <h3>Cálculo de Massa Molar</h3>

                        <div className="botao-icone" onClick={back}>
                            <IoMdArrowRoundBack size={20} />
                            <span>Voltar</span>
                        </div>
                    </div>

                    <div className="linha-nivel">
                        <span className="nivel"><strong>Nível</strong>: Introdutório</span>
                    </div>

                    <p>Aqui você poderá calcular a massa molar para qualquer substância química, basta que você escreva a fórmula molecular no espaço indicado. Lembre-se de que os elementos químicos possuem diferenciação entre letras maiúsculas e minúsculas.</p>

                    <div className="form-ferramenta">
                        <label>Fórmula Molecular</label>
                        <input type="text" value={formula} onChange={alterar} />
                    </div>

                    <div className="grid-row">
                        <p className="alerta-ferramenta">{alerta}</p>
                    </div>

                    {carregado && <div className="area-mm">
                        <p><b>Massa Molar</b>: {massaMolar(mm)}</p>

                        <table>
                            <tr>
                                <th>Elemento</th>
                                <th>Porcentagem</th>
                            </tr>
                            {composicao.map(item => (
                                <tr>
                                    <td>{item.elemento.nome} ({item.elemento.simbolo})</td>
                                    <td>{porcentagem(item.porcentagem)}</td>
                                </tr>
                            ))}
                        </table>    
                    </div>}

                </div>
            </div>

        </div>
    );
}